import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Products from "@/components/Products";
import CatalogDownload from "@/components/CatalogDownload";
import Services from "@/components/Services";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

function Home() {
  return (
    <div className="min-h-screen bg-white font-barlow">
      <Navbar />
      <Hero />
      <About />
      <Products />
      <CatalogDownload />
      <Services />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default Home;
